export default "/assets/images/filter-basic-breather.webp?f0cf9561145a42f84160db71de24c816";